import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { PopUpService } from '../../../core';
import { TranslateService } from '@ngx-translate/core';
import { TutorizationQuestionService } from './tutorization-question.service';

@Injectable()
export class TutorizationGroupService {
  constructor(
    public location: Location,
    public questionsService: TutorizationQuestionService,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  private goBack() {
    this.location.back();
  }

  private refresh() {
    window.location.reload();
  }

  private callback(refresh) {
    if (refresh) {
      this.refresh();
    } else {
      this.goBack();
    }
  }

  deleteQuestion(questionId, refresh = false) {
    return this.popupService
      .confirmDelete({
        title: this.translate.instant('customizations.documents.questions.confirmDelete'),
        text: this.translate.instant('customizations.documents.questions.deleteMessage')
      })
      .then(() => this.questionsService.delete(questionId))
      .then(() => this.callback(refresh))
      .catch((err) => {
        if (err !== 'cancel' && err !== 'esc') {
          this.popupService.showError({
            title: this.translate.instant('customizations.documents.questions.deleteError'),
            text: err.serverMessage
          });
        }
      });
  }

  cancelQuestion(questionId, refresh = false) {
    this.popupService
      .confirm({
        title: this.translate.instant('customizations.documents.questions.confirmCancel'),
        text: this.translate.instant('customizations.documents.questions.cancelMessage')
      })
      .then(() => this.questionsService.cancelQuestion(questionId))
      .then(() => this.callback(refresh))
      .catch((err) => {
        if (err !== 'cancel' && err !== 'esc') {
          this.popupService.showError({
            title: this.translate.instant('customizations.documents.questions.cancelError'),
            text: err.serverMessage
          });
        }
      });
  }

  publishQuestion(questionId, refresh = false) {
    this.popupService
      .confirm({
        title: this.translate.instant('customizations.documents.questions.confirmPublish'),
        text: this.translate.instant('customizations.documents.questions.publishMessage')
      })
      .then(() => this.questionsService.publishQuestion(questionId))
      .then(() => this.callback(refresh))
      .catch((err) => {
        if (err !== 'cancel' && err !== 'esc') {
          this.popupService.showError({
            title: this.translate.instant('customizations.documents.questions.publishError'),
            text: err.serverMessage
          });
        }
      });
  }

  certifyQuestion(questionId, refresh = false) {
    this.popupService
      .confirm({
        title: this.translate.instant('customizations.documents.questions.confirmCertify'),
        text: this.translate.instant('customizations.documents.questions.certifyMessage')
      })
      .then(() => this.questionsService.certifyQuestion(questionId))
      .then(() => this.callback(refresh))
      .catch((err) => {
        if (err !== 'cancel' && err !== 'esc') {
          this.popupService.showError({
            title: this.translate.instant('customizations.documents.questions.certifyError'),
            text: err.serverMessage
          });
        }
      });
  }
}
